import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmarkSlash = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.56494 2.0176C1.22945 1.77466 0.760538 1.84968 0.517598 2.18517C0.274657 2.52066 0.349683 2.98957 0.685172 3.23251L5.00006 6.35709V21.2587C5.00006 21.5471 5.16545 21.81 5.42545 21.9348C5.68546 22.0596 5.99401 22.0243 6.21907 21.8439L12.0001 17.2112L17.781 21.8439C18.0061 22.0243 18.3147 22.0596 18.5747 21.9348C18.8347 21.81 19.0001 21.5471 19.0001 21.2587V16.495L22.4352 18.9825C22.7707 19.2255 23.2396 19.1504 23.4825 18.8149C23.7255 18.4794 23.6504 18.0105 23.3149 17.7676L1.56494 2.0176ZM17.5001 15.4088L6.50006 7.44329V19.6965L11.531 15.6648C11.8051 15.4451 12.195 15.4451 12.4691 15.6648L17.5001 19.6965V15.4088Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.25006 2.00006C6.83585 2.00006 6.50006 2.33585 6.50006 2.75006C6.50006 3.16427 6.83585 3.50006 7.25006 3.50006H17.2501C17.3881 3.50006 17.5001 3.61199 17.5001 3.75006V10.2501C17.5001 10.6643 17.8358 11.0001 18.2501 11.0001C18.6643 11.0001 19.0001 10.6643 19.0001 10.2501V3.75006C19.0001 2.78356 18.2166 2.00006 17.2501 2.00006H7.25006Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgBookmarkSlash;
